export default __webpack_public_path__ + "static/media/over-axle-axlesGroup-size.94162855.svg";